import React, { useCallback, useMemo } from 'react';
import { ChangeLanguageDialog } from '@colonist/clientforge';
import { I18n } from '@colonist/i18n';
import { StringUtils } from '@colonist/utils';
import { clientIntl, replaceLanguageInPath } from '../ClientI18n.ts';
import { StorageWrapper } from '../StorageWrapper.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
function buildLanguageOptions() {
    const options = [];
    I18n.languages.forEach((languageCode)=>{
        const languageName = clientIntl.getLanguageName(languageCode);
        if (languageName == undefined) return;
        const nativeLanguageName = clientIntl.getLanguageName(languageCode, languageCode);
        if (nativeLanguageName == undefined) return;
        const languageNameCapitalized = StringUtils.capitalizeFirstLetter(languageName);
        const nativeLanguageNameCapitalized = StringUtils.capitalizeFirstLetter(nativeLanguageName);
        const label = `${languageNameCapitalized} (${nativeLanguageNameCapitalized})`;
        options.push({
            code: languageCode,
            label: label
        });
    });
    return options;
}
export const ChangeLanguageDialogContainer = ({ open, onClose })=>{
    const currentLanguage = UIUtilsEjsVariables.language;
    const languages = useMemo(()=>buildLanguageOptions(), []);
    const changeLanguage = useCallback(async (languageCode)=>{
        onClose();
        StorageWrapper.setLanguagePreferenceSelected(true);
        StorageWrapper.setLanguage(languageCode);
        if (languageCode == currentLanguage) return;
        const dataToSend = {
            language: languageCode
        };
        await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiSetUserLanguage(), undefined, dataToSend, 'application/json');
        window.location.pathname = replaceLanguageInPath(window.location.pathname, languageCode);
    }, [
        currentLanguage,
        onClose
    ]);
    return /*#__PURE__*/ React.createElement(ChangeLanguageDialog, {
        open: open,
        languages: languages,
        currentLanguage: currentLanguage,
        onClose: onClose,
        onConfirm: (languageCode)=>void changeLanguage(languageCode)
    });
};
